import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';

const getActionReporter = (startTime: number, additionalContext = {}) => {
  return () => {
    const loadEnd = performance.now();
    const loadTime = loadEnd - startTime;
    datadogRum.addAction('Loading Viewed', {
      duration: loadTime,
      ...additionalContext
    });
  };
};

function useLoadTimeTracking(additionalContext = {}) {
  useEffect(() => {
    try {
      const loadStart = performance.now();
      const actionReporter = getActionReporter(loadStart, additionalContext);
      window.addEventListener('beforeunload', actionReporter);
      return () => {
        try {
          window.removeEventListener('beforeunload', actionReporter);
          actionReporter();
        } catch {}
      };
    } catch {}
  });
}

export default useLoadTimeTracking;
